import { connectMediaStore } from './withOwnReduxStore';
import { onSelectableItemClick } from '../actions';
import { getSelectedDeviationIds, getSelectionLimit } from '../selectors';
import { getDeviationsByIds } from '../../redux/deviations/selectors';
var mapStateToProps = function (state, ownProps) {
    var selectionLimit = getSelectionLimit(state) || ownProps.selectionLimit;
    var selectedDeviationIds = getSelectedDeviationIds(state);
    var selectedDeviations = getDeviationsByIds(state, getSelectedDeviationIds(state));
    return {
        selectionLimit: selectionLimit,
        selectedDeviationIds: selectedDeviationIds,
        selectedDeviations: selectedDeviations,
        selectedCount: selectedDeviations.length,
        canSelectMore: selectionLimit && selectedDeviations.length < selectionLimit,
    };
};
var mapDispatchToProps = { onSelectableItemClick: onSelectableItemClick };
export default connectMediaStore(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=withSelectedDeviations.js.map